import { render, staticRenderFns } from "./intervention_material_edit.vue?vue&type=template&id=3279d7a1&scoped=true&"
import script from "./intervention_material_edit.vue?vue&type=script&lang=js&"
export * from "./intervention_material_edit.vue?vue&type=script&lang=js&"
import style0 from "./intervention_material_edit.vue?vue&type=style&index=0&id=3279d7a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279d7a1",
  null
  
)

export default component.exports